import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { useMemo } from "react";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { encodePaintConfiguratorUrlState } from "../../helpers/state.helper";
import { ProductsContextProvider } from "./context/products.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { state } = usePaintConfiguratorContext();

    const encodedState = useMemo(() => {
        const { colorHex, colorId, colorName } = state;

        return encodePaintConfiguratorUrlState(colorId, colorHex, colorName);
    }, [state]);

    return (
        <ProductsContextProvider
            colorId={state.colorId}
            urlState={encodedState}
        >
            {children}
        </ProductsContextProvider>
    );
};

export { Base };
